import { render } from "./HomeActionsBarAlbumTools.vue?vue&type=template&id=d67a4350&scoped=true"
import script from "./HomeActionsBarAlbumTools.vue?vue&type=script&lang=js"
export * from "./HomeActionsBarAlbumTools.vue?vue&type=script&lang=js"

import "./HomeActionsBarAlbumTools.vue?vue&type=style&index=0&id=d67a4350&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d67a4350"

export default script